export default "__VITE_ASSET__CJTdDeGS__"